import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dotCmsCodecEncode',
})
export class DotCmsCodecEncodePipe implements PipeTransform {
  codec = new HttpUrlEncodingCodec();

  transform(src: string): string {
    // Manipulate the 'value' based on custom logic using arg1 and arg2
    // For example, let's concatenate arg1 and arg2 to the value
    return this.codec.encodeValue(src);
  }
}
